import { Working } from '@ui/Working';
import { ReasoningResultContext, RUNNING_STATUS } from '@/contexts/ReasoningResultContext';
import { Body5, Container } from '@ui';
import React from 'react';
import { RefiningAnswer } from './components/RefiningAnswer';
import { Followup } from './components/Followup';
import { ModeContext } from '@/contexts/ModeContext';
import styled from 'styled-components';
import { ReasoningAnswer } from './components/ReasoningAnswer';
import { ReasoningAnswerReasoning } from './components/ReasoningAnswerReasoning';
import { SkeletonButton } from '@ui/buttons/SkeletonButton';
import { ReasoningChatContext } from './reasoningChat/ReasoningChatContext';
import { ReasoningChatPanel } from './reasoningChat/ReasoningChatPanel';
import { QueryControllerContext } from '@/contexts/QueryControllerContext';

const ForceButtonWidth = styled.div`
  button {
    width: 240px;
  }
`;

const ReasoningStreamingResult = () => {
  const { enableFollowUpQuestions } = React.useContext(ModeContext);
  const { runningStatus, answer, reasoning } = React.useContext(ReasoningResultContext);
  const { prevQueryFormData } = React.useContext(QueryControllerContext);
  const { openChat } = React.useContext(ReasoningChatContext);

  const handleChatAboutAnswer = () => {
    const question = prevQueryFormData?.displayQuestion || prevQueryFormData?.question || '';
    openChat(question, answer || '', reasoning || '');
  };

  const isCompleted = runningStatus === RUNNING_STATUS.COMPLETED;

  return (
    <Container>
      <Container bottom={16}>
        <Body5 bold>Answer:</Body5>
      </Container>
      {runningStatus === RUNNING_STATUS.REFINING && (
        <Container>
          <RefiningAnswer />
        </Container>
      )}
      <Container left={16}>
        <ReasoningAnswer />
      </Container>
      {runningStatus === RUNNING_STATUS.RUNNING && (
        <Container top={12} left={16}>
          <Working noVerticalPadding />
        </Container>
      )}
      <Container top={16}>
        <Body5 bold>Reasoning:</Body5>
      </Container>
      <Container left={16} top={16}>
        <ReasoningAnswerReasoning />

        {runningStatus === RUNNING_STATUS.RUNNING && (
          <Container top={12}>
            <Working noVerticalPadding />
          </Container>
        )}
      </Container>
      {enableFollowUpQuestions && <Followup />}
      {isCompleted && (
        <Container top={24}>
          <ForceButtonWidth>
            <SkeletonButton onClick={handleChatAboutAnswer}>Chat About Answer</SkeletonButton>
          </ForceButtonWidth>
        </Container>
      )}
      <Container top={24} />
      <ReasoningChatPanel />
    </Container>
  );
};

export default ReasoningStreamingResult;
